import { HelpButton } from "@components/HelpButton";
import { NavItem } from "@components/Settings/NavItem";
import { WithPermission } from "@components/WithPermission";
import { settingsRoutes } from "@constants/routes";
import HexagonIcon from "@lyteflo/assets/icons/hexagon.svg?react";
import { Button, Popover } from "@lyteflo/components";
import { toFeatureList, useMobile } from "@lyteflo/utils";
import { useRef, useState } from "preact/compat";
import { useTranslation } from "react-i18next";

export const Menu = () => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="lf-flex lf-justify-center lf-items-center lf-ml-3 lf-pr-4 lf-relative lf-gap-2">
      <HelpButton />
      <Button
        ref={buttonRef}
        color="gray"
        variant="ghost"
        className="lf-h-8 lf-flex lf-items-center lf-gap-2 lf-p-2"
        onClick={() => setIsOpen((v) => !v)}
      >
        <HexagonIcon className="lf-shrink-0 lf-h-6 lf-w-6" />
        {!isMobile && <span>{t("navigation.settings")}</span>}
      </Button>
      <Popover
        triggerRef={buttonRef}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        side="bottom"
        align="end"
        className="lf-rounded-md lf-shadow-lg lf-p-1"
        zIndex={50}
        offset={12}
      >
        <div>
          {settingsRoutes.map(
            ({
              path,
              labelKey,
              icon: Icon,
              iconClassName,
              iconColorClassName,
              feature,
              requiredLevel,
              hidden,
            }) => {
              if (hidden) return null;
              return (
                <WithPermission
                  key={path}
                  features={toFeatureList(feature)}
                  requiredLevel={requiredLevel}
                >
                  <NavItem
                    path={path}
                    label={t(labelKey)}
                    Icon={Icon}
                    iconClassName={iconClassName}
                    iconColorClassName={iconColorClassName}
                    className="lf-py-1"
                  />
                </WithPermission>
              );
            },
          )}
        </div>
      </Popover>
    </div>
  );
};
